import React, { Component, PropTypes } from "react";
import { Media, Image } from "react-bootstrap";

export default class MediaList extends Component {

  static propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.element
  };

  render() {
    const { children, title, icon } = this.props;

    const titleContent = title && <Media.Heading>{title}</Media.Heading>;
    return (
      <Media>
        <Media.Left>
          <Image circle width={60} height={60}
                 src={icon} alt="Image"/>
        </Media.Left>
        <Media.Body>
          {titleContent}
          {children}
        </Media.Body>
      </Media>
    )

  }
}



// WEBPACK FOOTER //
// ./src/components/MediaList.js